import React from 'react';
import { Col, Modal, Row, Button } from 'react-bootstrap';
import * as Formatting from 'fw/misc/Formatting';
import * as ReportManager from 'modules/reports/ReportManager';
import { faFilePdf, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import API from 'fw/system/API';

class OnlinePaymentInfoPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible
        });
    }

    close = () => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onClose();
        });
    }

    handleDownload = () => {
        const rq = Object.assign({
            reportType: "PaymentInfoReport",
            format: "PDF",
            parameters: {
                CertificationId: this.props.certificationId,
                PaymentDate: Formatting.formatDateTime(this.props.onlinePayment.paymentDate),
                PaymentAmount: Formatting.formatCurrency(this.props.onlinePayment.paymentAmount)
            }
        });

        ReportManager.execute(rq);
        this.close()
    };

    handleComplementaryDownload = () => {
        new API().download({
            storageToken: this.props.onlinePayment.paymentInfoStorageToken,
            fileName: this.props.onlinePayment.paymentInfoFileName
        });
    };

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-60w">
                <Modal.Header>
                    <h3>Online Payment Information – <small>Transaction Details</small></h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        <Row>
                            <Col md={12}>
                                { this.props.onlinePayment == null ?
                                    <React.Fragment>
                                        <Row>
                                            <Col md={12}>
                                                <h5><em>No payment information available</em></h5>
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                :
                                <React.Fragment>
                                    <Row>
                                        <Col md={1}></Col>
                                        <Col md={5}>
                                            <p>
                                                Payment status
                                                <br />
                                                <b style={{fontSize:"14pt"}}>{this.props.onlinePayment.paymentStatus}</b>
                                            </p>
                                        </Col>
                                        <Col md={5}>
                                            <p style={{textAlign:"right"}}>
                                                Application Fee
                                                <br />
                                                <b style={{fontSize:"14pt"}}>{Formatting.formatCurrency(this.props.onlinePayment.paymentAmount)} USD</b>
                                            </p>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col md={2}></Col>
                                        <Col md={8}>
                                            <table className="table table-bordered table-condensed">
                                                <thead>
                                                    <tr style={{backgroundColor:"#D3D1D0"}}>
                                                        <th colspan="2">
                                                            Payment information
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            Payment Date
                                                        </td>
                                                        <td>
                                                            <b>{Formatting.formatDateTime(this.props.onlinePayment.paymentDate)}</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Transaction ID
                                                        </td>
                                                        <td>
                                                            <b>{this.props.onlinePayment.transactionId}</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            FEIN
                                                        </td>
                                                        <td>
                                                            <b>{this.props.onlinePayment.vobFein}</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Application ID
                                                        </td>
                                                        <td>
                                                            <b>{this.props.onlinePayment.certificationId}</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Payment detail
                                                        </td>
                                                        <td>
                                                            <b>{this.props.onlinePayment.itemName}</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Application fee
                                                        </td>
                                                        <td>
                                                            <b>{Formatting.formatCurrency(this.props.onlinePayment.paymentAmount)} USD</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Paid by
                                                        </td>
                                                        <td>
                                                            <b>{this.props.onlinePayment.payerName}</b>
                                                            <br />
                                                            <small>
                                                                The sender of this payment is <b>{this.props.onlinePayment.payerStatus}</b>
                                                                <br />
                                                                <b>{this.props.onlinePayment.payerEmail}</b>
                                                            </small>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Payment sent to
                                                        </td>
                                                        <td>
                                                            <b>{this.props.onlinePayment.receiverEmail}</b>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={2}>
											<Button type="button" bsStyle="link" onClick={() => this.handleDownload()} style={{ textAlign: 'center', display: 'block' }}>
                                                Download Payment Info
                                                <br />
                                                <FontAwesomeIcon icon={faFilePdf} size='3x' color='black' style={{ textAlign: 'center' }} />
											</Button>
                                        </Col>
                                        <Col md={3}>
                                            {this.props.onlinePayment.paymentInfoFileName != null &&
												<Button type="button" bsStyle="link" onClick={() => this.handleComplementaryDownload()} style={{ textAlign: 'center', display: 'block' }}>
                                                    Download Complementary Payment Info 
                                                    <br />
                                                    <FontAwesomeIcon icon={faFileDownload} size='3x' color='black' style={{ textAlign: 'center' }} />
												</Button>
                                            }
                                        </Col>
                                    </Row>
                                </React.Fragment>}
                            </Col>
                        </Row>
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default OnlinePaymentInfoPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/companyInfo/OnlinePaymentInfoPopUp.js